import basic from "./basic.json";
import layout from "./layout.json";
import eventTypeString from "./eventTypeString.json";
import eventReport from "./eventReport.json";
import login from "../../pages/Login/locales/ja.json";
import fleetMap from "../../pages/FleetMap/locales/ja.json";
import eventCenter from "../../pages/EventCenter/locales/ja.json";
import playback from "../../pages/Playback/locales/ja.json";
import settings from "../../pages/Settings/locales/ja.json";
import liveStream from "../../pages/LiveStream/locales/ja.json";
import installApp from "../../components/InstallAppButton/locales/ja.json";
import notifications from "../../pages/Notifications/locales/ja.json";
import home from "../../pages/Home/locales/ja.json";
import periodicReport from "../../pages/PeriodicReport/locales/ja.json";
import changePassword from "../../pages/ChangePassword/locales/ja.json";

export const ja = {
  ...basic,
  ...layout,
  ...eventTypeString,
  ...eventReport,
  ...login,
  ...fleetMap,
  ...eventCenter,
  ...playback,
  ...settings,
  ...liveStream,
  ...installApp,
  ...notifications,
  ...home,
  ...periodicReport,
  ...changePassword,
};
